<template>
  <div class="authenticate">
    <div class="p-4 float-right">
    </div>
    <router-link :to="{name:'Home'}" class="p-2 float-left">
      <img class="logo-top" :src="this.StaticImageUrl+'assets/images/logo/logo-dark.png'">
    </router-link>

    <div class="form-out">
      <div class="form-in text-center">

        <div class="icon-lg">
          <div class="icon-wrapper">
            <img :src="this.StaticImageUrl+'assets/images/site-icons/mobile-alt.svg'" alt="">
          </div>
        </div>

        <div class="ar-form-group">
          <div class="ar-form-append">
            <input class="ar-form-control text-center latin-input-3" v-model="password" :type="[show_password ? 'text' : 'password']" placeholder="رمز عبور" />
            <span class="ar-form-icon" @click="show_password = !show_password">
              <i v-if="show_password" class="fa fa-eye"></i>
              <i v-else class="fa fa-eye-slash"></i>
            </span>
          </div>
          <div v-if="errors.password" class="ar-form-text">
            <small>{{errors.password[0]}}</small>
          </div>
        </div>
        <div class="ar-form-group">
          <input class="ar-form-control text-center latin-input-3" v-model="data.password_confirmation" :type="[show_password ? 'text' : 'password']" placeholder="تکرار رمز عبور" />
          <div v-if="errors.password_confirmation" class="ar-form-text">
            <small>{{errors.password_confirmation[0]}}</small>
          </div>
        </div>

        <div class="py-3 text-right" style="font-size:12px">
          <div>رمز عبور شما باید شامل این موارد باشد:</div>
          <div>
            <span>
              <i v-if="!pp.a" class="fa fa-square-o"></i>
              <i v-else class="fa fa-check-square-o"></i>
            </span>
            حروف بزرگ و کوچک انگلیسی
          </div>
          <div>
            <span>
              <i v-if="!pp.b" class="fa fa-square-o"></i>
              <i v-else class="fa fa-check-square-o"></i>
            </span>
            عدد
          </div>
          <div>
            <span>
              <i v-if="!pp.c" class="fa fa-square-o"></i>
              <i v-else class="fa fa-check-square-o"></i>
            </span>
            علائم (@ , / , % و ...)
          </div>
        </div>

        <h4 v-if="errorMessage" class="text-center mb-2 t2-c">
          <small>{{errorMessage}}</small>
        </h4>

        <div class="mb-4">
          <button @click="SetPassword()" class="ar-btn size-md block round primary">تایید</button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'SetPassword',
  data : () => ({
    data:{},
    errorMessage:null,
    errors:{},
    pp:{
      a:false,
      b:false,
      c:false,
    },
    password : null,
    show_password : false,
  }),
  watch:{
    password(){
      const pass = this.password
      if(/\d/.test(pass)){
        this.pp.b = true
      }else{
        this.pp.b = false
      }

      const
      upper = /[A-Z]/.test(pass),
      lower = /[a-z]/.test(pass);
      if(upper && lower){
        this.pp.a = true
      }else{
        this.pp.a = false
      }
      
      if(/[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(pass)){
        this.pp.c = true
      }else{
        this.pp.c = false
      }
    }
  },
  methods:{
    SetPassword(){
      const api_token = this.getToken()
      this.activeLoading(true)
      this.data.password = this.password
      this.$axios.post(`SetPassword` , this.data ,
      {
        headers: {
          'api_token':api_token
        }
      })
      .then(res => {
        this.activeLoading(false)
        this.authUser(res.data.data)
        this.$router.push({name:'Dashboard'});
      })
      .catch(err => {
        if(err.response.data.message){
          this.errorMessage = err.response.data.message
          this.errors = {}
        }else if(err.response.data.errors){
          this.errors = err.response.data.errors
          this.errorMessage = null
        }
        this.activeLoading(false)
      });
    }
  },
  mounted() {
    this.activeLoading(false)
    this.checkAuth()
  }
}
</script>
